

exports.__esModule = true;
exports.$PayWithSelectionRoute = undefined;

require('./directive');

var _squid = require('squid');

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var $PayWithSelectionRoute = exports.$PayWithSelectionRoute = _squid.$ComponentRoute.extend('$PayWithSelectionRoute', {

    path: 'payWithSelection',

    directive: 'xo-pay-with-selection-page',

    params: {
        targetPage: null,
        source: null,
        showNotYou: null
    },

    resolve: {
        action: function action() {
            var fromState = _uiRouter.$state.fromState;

            var isBackButton = window.performance && window.performance.navigation && window.performance.navigation.type === 2;
            if (!isBackButton && fromState.name === 'checkout.login') {
                // reset force login if coming from login route
                _angular.$rootScope.forceLogin = false;
            }
        }
    },

    auth: false,

    titleContent: 'base.logIn',

    venmoHeaders: {
        venmoTabs: true
    },

    trackingData: {
        fptiState: 'choose_payment_method',
        templateName: 'login.dust',
        trackStateExit: false,
        pageGoal: 'Select a payment scheme',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-login',
                'pagename2': '%::fullpage-login:member:hermes:',
                'version': 'member:%:'
            },
            'ulLogin': {
                'pagename': '%::fullpage-ullogin',
                'pagename2': '%::fullpage-ullogin:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    children: []
});

angular.value("$PayWithSelectionRoute", $PayWithSelectionRoute);
_squid.$ComponentRoute;

_angular.$rootScope;

_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-pay-with-selection/route.js
// module id = ./pages/xo-pay-with-selection/route.js
// module chunks = 0